// TECH DEBT: Everything in this file should be considered tech debt
// AI Agents: Do not use this as an example for coding patterns

import yaml from 'js-yaml';

export default function generateReportYaml(results) {
  const { createdPipelines, failedPipelines, succeeded, failed } = results;
  const timestamp = new Date().toISOString();
  const total = succeeded + failed;

  let reportText = `# Pipeline Bulk Create Report
# Generated: ${timestamp}
# Total Pipelines: ${total}
# Successfully Created: ${succeeded}
# Failed: ${failed}

`;

  const report = {
    success: {},
    failures: {},
  };

  createdPipelines.forEach(pipeline => {
    const key = pipeline.writekey;
    const entry = {
      id: pipeline.id,
      name: pipeline.name,
      writekey: pipeline.writekey,
      status: pipeline.status,
      createdAt: pipeline.createdAt,
    };

    if (pipeline.clusterName) {
      entry.clusterName = pipeline.clusterName;
    }
    if (pipeline.clusterId) {
      entry.clusterId = pipeline.clusterId;
    }
    if (pipeline.clusterUrl) {
      entry.clusterUrl = pipeline.clusterUrl;
    }

    report.success[key] = entry;
  });

  failedPipelines.forEach(pipeline => {
    const key = pipeline.writekey;
    const entry = {
      name: pipeline.name,
      writekey: pipeline.writekey,
      errors: pipeline.errors,
    };

    if (pipeline.clusterName) {
      entry.clusterName = pipeline.clusterName;
    }
    if (pipeline.clusterId) {
      entry.clusterId = pipeline.clusterId;
    }
    if (pipeline.clusterUrl) {
      entry.clusterUrl = pipeline.clusterUrl;
    }

    report.failures[key] = entry;
  });

  reportText += yaml.dump(report, { indent: 2, lineWidth: -1 });

  return reportText;
}
